<template>
	<vs-button @click.native="$emit('click', $event)" :type="type" :color="color" :text-color="textColor" :icon-after="iconAfter" :line-origin="lineOrigin"
			   :line-position="linePosition" :gradient-direction="gradientDirection" :gradient-color-secondary="gradientColorSecondary"
			   :radius="radius" :to="to" :href="href" :target="target" :routeErr="routeErr" :icon-pack="icon[0]" :icon="'fa-' + icon[1]" >
		<slot></slot>
	</vs-button>
</template>

<script>
export default{
	name: 'vx-button',
	props: {
		type: {
			type: String,
			default: 'filled',
		},
		color: {
			type: String,
			default: 'primary',
		},
		textColor: {
			type: String,
		},
		icon: {
			type: Array,
			default: () => ['', ''],
		},
		iconAfter: {
			type: Boolean,
			default: false,
		},
		lineOrigin: {
			type: String,
			default: 'center',
		},
		linePosition: {
			type: String,
			default: 'center',
		},
		gradientDirection: {
			type: String,
			default: '30 deg',
		},
		gradientColorSecondary: {
			type: String,
			default: 'primary',
		},
		radius: {
			type: Boolean,
			default: false,
		},
		to: {
			type: String | Object,
			default: false,
		},
		href: {
			type: String | Object,
		},
		target: {
			type: Boolean,
			default: false,
		},
		routeErr: {
			type: Event
		},
	},
}
</script>
